import type React from "react";
import { useSelector } from "react-redux";

import type { RootState } from "../../store";

import Footer from "./Footer";
import Header from "./Header";
import NotificationContainer from "./NotificationContainer";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { theme } = useSelector((state: RootState) => state.ui);

  return (
    <div className={`min-h-screen bg-background text-foreground ${theme}`}>
      <Header />
      <main className='flex-1'>{children}</main>
      <Footer />
      <NotificationContainer />
    </div>
  );
};

export default Layout;
